import { useCurrentUserContext } from '@/contexts/CurrentUserContext';
import { usePageExperienceContextOptional } from '@/features/experiences/contexts/PageExperienceContext';

// On an experience page the nav is the trail's root crumb, Library, which reads
// as a claim that the experience sits in the viewer's own library. A published
// page reached by link usually doesn't, so the trail starts at the title there.
export const useIsHeaderNavVisible = (): boolean => {
  const { isAuthenticated } = useCurrentUserContext();
  const pageExperience = usePageExperienceContextOptional();

  return isAuthenticated && !pageExperience?.isPublishedView;
};
